module.exports = __webpack_public_path__ + "img/Listening_to_molecule_thinking.83b8346b.gif";